exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".preloader{height:100vh;background:#fde5e5;position:absolute;color:#781115;font-family:Raleway,sans-serif;position:relative}.preloader,.preloader__status{width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center}.preloader__status-text{font-size:40px;font-family:Raleway,sans-serif;margin-bottom:20px}.preloader__status-loader{width:100%;height:3px}.preloader__status-bar{background:#781115;height:100%}.frontpage{height:100vh;background:#34495e}.frontpage__title{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24c49126","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./vue-source/src/app/components/preload.vue
// module id = 172
// module chunks = 0